"use client";

import React from "react";

//Types
import { ImageProps } from "@/types";

//styles
import * as S from "./styles";

const Image: React.FC<ImageProps> = ({ src, className, onClick }) => {
  if (!src) return null;

  const imageUrl = typeof src === "string" ? src : src.src;

  return (
    <S.ImageComponent
      className={className}
      src={imageUrl}
      onClick={onClick}
      alt="Image"
    />
  );
};

export default Image;
